module.exports = __webpack_public_path__ + "static/media/2017-lm-vorau.37a2b2d7.jpg";